import React from 'react';
import { Box, Link, Text } from '@stitch-fix/mode-react';

import './styles.module.scss';

const BagFooter = () => {
  const loginRedirectUrl = encodeURIComponent('/product/shopping_bag');
  const loginHref = `/login?ret=${loginRedirectUrl}`;

  return (
    <Box as="footer" styleName="bag-footer-wrapper">
      <Text setting="body-small">
        Already have an account? <Link href={loginHref}>Sign in</Link>
      </Text>
    </Box>
  );
};

export default BagFooter;
